// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader_loaderWrapper__2wuez","loader":"Loader_loader__1j2Bs","spin":"Loader_spin__3E4o4"};